// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Pdn-N","fullView":"styles_fullView__3ViUJ"};